import type { ModerationState } from "@/redux/discussions/types";
import { STATUS_CHIP_VARIANTS } from "@/components_v2/StatusChip/constants";
import { MODERATION_STATES } from "@/domains/moderation/constants";
import type {
  CaseKind,
  ModerationFiltersState,
  StatusFilter,
} from "@/features/community/moderation/types";

export const STATUS_FILTER_KEYS = {
  WAITING: "waiting",
  APPROVED: "approved",
  REMOVED: "removed",
  ALL: "all",
} as const;

export const STATUS_FILTERS = [
  STATUS_FILTER_KEYS.WAITING,
  STATUS_FILTER_KEYS.APPROVED,
  STATUS_FILTER_KEYS.REMOVED,
  STATUS_FILTER_KEYS.ALL,
] as const;

export const STATUS_STATES: Record<StatusFilter, ModerationState[]> = {
  all: [
    MODERATION_STATES.PENDING_AI,
    MODERATION_STATES.AI_REVIEWING,
    MODERATION_STATES.PENDING_HUMAN,
    MODERATION_STATES.APPROVED,
    MODERATION_STATES.REJECTED,
  ],
  waiting: [MODERATION_STATES.PENDING_HUMAN],
  approved: [MODERATION_STATES.APPROVED],
  removed: [MODERATION_STATES.REJECTED],
};

export const CASE_KINDS = {
  POST: "post",
  COMMENT: "comment",
  REPLY: "reply",
} as const satisfies Record<string, CaseKind>;

export const STATE_CHIPS: Partial<
  Record<
    ModerationState,
    {
      labelKey: string;
      variant: (typeof STATUS_CHIP_VARIANTS)[keyof typeof STATUS_CHIP_VARIANTS];
    }
  >
> = {
  PENDING_AI: {
    labelKey: "moderation.case.states.aiChecking",
    variant: STATUS_CHIP_VARIANTS.NEUTRAL,
  },
  AI_REVIEWING: {
    labelKey: "moderation.case.states.aiChecking",
    variant: STATUS_CHIP_VARIANTS.NEUTRAL,
  },
  PENDING_HUMAN: {
    labelKey: "moderation.case.states.waiting",
    variant: STATUS_CHIP_VARIANTS.AMBER,
  },
  APPROVED: {
    labelKey: "moderation.case.states.approved",
    variant: STATUS_CHIP_VARIANTS.BLUE,
  },
  REJECTED: {
    labelKey: "moderation.case.states.removed",
    variant: STATUS_CHIP_VARIANTS.RED,
  },
};

export const SORT_KEYS = {
  OLDEST: "oldest",
  NEWEST: "newest",
} as const;

export const SORT_OPTIONS = [SORT_KEYS.OLDEST, SORT_KEYS.NEWEST] as const;

export const CASE_ORDERINGS = {
  OLDEST_FIRST: "created_at",
  NEWEST_FIRST: "-created_at",
} as const;

export const DEFAULT_FILTERS: ModerationFiltersState = {
  status: STATUS_FILTER_KEYS.WAITING,
  author: null,
  sort: SORT_KEYS.OLDEST,
};

export const CASES_PAGE_SIZE = 10;

export const CASE_SKELETON_CARDS = 3;

export const COLLAPSE_AFTER_CHARACTERS = 640;
